import { f as getDocument, t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as Navigation } from "./navigation-BSfLh-wX.js";
import { t as Pagination } from "./pagination-U6_Jfzrd.js";
import { t as A11y } from "./a11y-DJiWS7ax.js";
//#region node_modules/.pnpm/swiper@9.4.1/node_modules/swiper/modules/autoplay/autoplay.js
function Autoplay({ swiper, extendParams, on, emit, params }) {
	swiper.autoplay = {
		running: false,
		paused: false,
		timeLeft: 0
	};
	extendParams({ autoplay: {
		enabled: false,
		delay: 3e3,
		waitForTransition: true,
		disableOnInteraction: true,
		stopOnLastSlide: false,
		reverseDirection: false,
		pauseOnMouseEnter: false
	} });
	let timeout;
	let raf;
	let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3e3;
	let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3e3;
	let autoplayTimeLeft;
	let autoplayStartTime = (/* @__PURE__ */ new Date()).getTime;
	let wasPaused;
	let isTouched;
	let pausedByTouch;
	let touchStartTimeout;
	let slideChanged;
	let pausedByInteraction;
	function onTransitionEnd(e) {
		if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
		if (e.target !== swiper.wrapperEl) return;
		swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
		resume();
	}
	const calcTimeLeft = () => {
		if (swiper.destroyed || !swiper.autoplay.running) return;
		if (swiper.autoplay.paused) wasPaused = true;
		else if (wasPaused) {
			autoplayDelayCurrent = autoplayTimeLeft;
			wasPaused = false;
		}
		const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - (/* @__PURE__ */ new Date()).getTime();
		swiper.autoplay.timeLeft = timeLeft;
		emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
		raf = requestAnimationFrame(() => {
			calcTimeLeft();
		});
	};
	const getSlideDelay = () => {
		let activeSlideEl;
		if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl) => slideEl.classList.contains("swiper-slide-active"))[0];
		else activeSlideEl = swiper.slides[swiper.activeIndex];
		if (!activeSlideEl) return void 0;
		return parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
	};
	const run = (delayForce) => {
		if (swiper.destroyed || !swiper.autoplay.running) return;
		cancelAnimationFrame(raf);
		calcTimeLeft();
		let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
		autoplayDelayTotal = swiper.params.autoplay.delay;
		autoplayDelayCurrent = swiper.params.autoplay.delay;
		const currentSlideDelay = getSlideDelay();
		if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
			delay = currentSlideDelay;
			autoplayDelayTotal = currentSlideDelay;
			autoplayDelayCurrent = currentSlideDelay;
		}
		autoplayTimeLeft = delay;
		const speed = swiper.params.speed;
		const proceed = () => {
			if (!swiper || swiper.destroyed) return;
			if (swiper.params.autoplay.reverseDirection) {
				if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
					swiper.slidePrev(speed, true, true);
					emit("autoplay");
				} else if (!swiper.params.autoplay.stopOnLastSlide) {
					swiper.slideTo(swiper.slides.length - 1, speed, true, true);
					emit("autoplay");
				}
			} else if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
				swiper.slideNext(speed, true, true);
				emit("autoplay");
			} else if (!swiper.params.autoplay.stopOnLastSlide) {
				swiper.slideTo(0, speed, true, true);
				emit("autoplay");
			}
			if (swiper.params.cssMode) {
				autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
				requestAnimationFrame(() => {
					run();
				});
			}
		};
		if (delay > 0) {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				proceed();
			}, delay);
		} else requestAnimationFrame(() => {
			proceed();
		});
		return delay;
	};
	const start = () => {
		swiper.autoplay.running = true;
		run();
		emit("autoplayStart");
	};
	const stop = () => {
		swiper.autoplay.running = false;
		clearTimeout(timeout);
		cancelAnimationFrame(raf);
		emit("autoplayStop");
	};
	const pause = (internal, reset) => {
		if (swiper.destroyed || !swiper.autoplay.running) return;
		clearTimeout(timeout);
		if (!internal) pausedByInteraction = true;
		const proceed = () => {
			emit("autoplayPause");
			if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
			else resume();
		};
		swiper.autoplay.paused = true;
		if (reset) {
			if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
			slideChanged = false;
			proceed();
			return;
		}
		autoplayTimeLeft = (autoplayTimeLeft || swiper.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - autoplayStartTime);
		if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
		if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
		proceed();
	};
	const resume = () => {
		if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
		autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
		if (pausedByInteraction) {
			pausedByInteraction = false;
			run(autoplayTimeLeft);
		} else run();
		swiper.autoplay.paused = false;
		emit("autoplayResume");
	};
	const onVisibilityChange = () => {
		if (swiper.destroyed || !swiper.autoplay.running) return;
		const document = getDocument();
		if (document.visibilityState === "hidden") {
			pausedByInteraction = true;
			pause(true);
		}
		if (document.visibilityState === "visible") resume();
	};
	const onPointerEnter = (e) => {
		if (e.pointerType !== "mouse") return;
		pausedByInteraction = true;
		pause(true);
	};
	const onPointerLeave = (e) => {
		if (e.pointerType !== "mouse") return;
		if (swiper.autoplay.paused) resume();
	};
	const attachMouseEvents = () => {
		if (swiper.params.autoplay.pauseOnMouseEnter) {
			swiper.el.addEventListener("pointerenter", onPointerEnter);
			swiper.el.addEventListener("pointerleave", onPointerLeave);
		}
	};
	const detachMouseEvents = () => {
		swiper.el.removeEventListener("pointerenter", onPointerEnter);
		swiper.el.removeEventListener("pointerleave", onPointerLeave);
	};
	const attachDocumentEvents = () => {
		getDocument().addEventListener("visibilitychange", onVisibilityChange);
	};
	const detachDocumentEvents = () => {
		getDocument().removeEventListener("visibilitychange", onVisibilityChange);
	};
	on("init", () => {
		if (swiper.params.autoplay.enabled) {
			attachMouseEvents();
			attachDocumentEvents();
			autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
			start();
		}
	});
	on("destroy", () => {
		detachMouseEvents();
		detachDocumentEvents();
		if (swiper.autoplay.running) stop();
	});
	on("beforeTransitionStart", (_s, speed, internal) => {
		if (swiper.destroyed || !swiper.autoplay.running) return;
		if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
		else stop();
	});
	on("sliderFirstMove", () => {
		if (swiper.destroyed || !swiper.autoplay.running) return;
		if (swiper.params.autoplay.disableOnInteraction) {
			stop();
			return;
		}
		isTouched = true;
		pausedByTouch = false;
		pausedByInteraction = false;
		touchStartTimeout = setTimeout(() => {
			pausedByInteraction = true;
			pausedByTouch = true;
			pause(true);
		}, 200);
	});
	on("touchEnd", () => {
		if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
		clearTimeout(touchStartTimeout);
		clearTimeout(timeout);
		if (swiper.params.autoplay.disableOnInteraction) {
			pausedByTouch = false;
			isTouched = false;
			return;
		}
		if (pausedByTouch && swiper.params.cssMode) resume();
		pausedByTouch = false;
		isTouched = false;
	});
	on("slideChange", () => {
		if (swiper.destroyed || !swiper.autoplay.running) return;
		slideChanged = true;
	});
	Object.assign(swiper.autoplay, {
		start,
		stop,
		pause,
		resume
	});
}
//#endregion
//#region src/scripts/extenders/hero-carousel.js
var HeroCarousel = class extends HTMLElement {
	connectedCallback() {
		this.handleBlockSelect = this.handleBlockSelect.bind(this);
		this.addEventListener("shopify:block:select", this.handleBlockSelect);
		this.initializeCarousel();
	}
	disconnectedCallback() {
		this.removeEventListener("shopify:block:select", this.handleBlockSelect);
		cancelAnimationFrame(this.controlColorFrame);
		this.carousel?.destroy(true, true);
	}
	initializeCarousel() {
		const carouselElement = this.querySelector(".hero__swiper");
		const slideCount = this.prepareSlides();
		if (!carouselElement || slideCount === 0) return;
		const hasMultipleSlides = slideCount > 1;
		this.classList.toggle("hero__carousel--single", !hasMultipleSlides);
		this.carousel = new Swiper(carouselElement, this.createOptions(hasMultipleSlides));
	}
	prepareSlides() {
		const slides = this.querySelectorAll(".hero__slides > .shopify-block");
		slides.forEach((slide) => slide.classList.add("swiper-slide"));
		return slides.length;
	}
	createOptions(hasMultipleSlides) {
		return {
			modules: [
				A11y,
				Autoplay,
				Navigation,
				Pagination
			],
			a11y: { enabled: true },
			autoplay: this.createAutoplayOptions(hasMultipleSlides),
			loop: hasMultipleSlides,
			navigation: {
				nextEl: this.querySelector(".hero__arrow--next"),
				prevEl: this.querySelector(".hero__arrow--previous")
			},
			pagination: {
				clickable: true,
				el: this.querySelector(".hero__pagination")
			},
			on: {
				init: (swiper) => this.handleActiveSlideChange(swiper),
				slideChange: (swiper) => this.handleActiveSlideChange(swiper)
			},
			watchOverflow: true
		};
	}
	handleActiveSlideChange(swiper) {
		this.updateControlColor(swiper);
		this.playActiveVideo(swiper);
	}
	async playActiveVideo(swiper) {
		const activeSlide = swiper.slides[swiper.activeIndex];
		const mediaClass = window.matchMedia("(min-width: 1024px)").matches ? ".hero__media-item--desktop" : ".hero__media-item--mobile";
		const activeVideo = activeSlide?.querySelector(`${mediaClass} video`);
		this.querySelectorAll("video").forEach((video) => video.pause());
		if (!activeVideo) return;
		try {
			await activeVideo.play();
		} catch (error) {
			console.warn("Hero video autoplay was prevented.", error);
		}
	}
	updateControlColor(swiper) {
		const slideContent = swiper.slides[swiper.activeIndex]?.querySelector(".hero__slide");
		if (!slideContent) return;
		const mobileColor = slideContent.style.getPropertyValue("--hero-slide-control-color-mobile");
		const desktopColor = slideContent.style.getPropertyValue("--hero-slide-control-color-desktop");
		cancelAnimationFrame(this.controlColorFrame);
		this.controlColorFrame = requestAnimationFrame(() => {
			this.style.setProperty("--hero-control-color-mobile", mobileColor);
			this.style.setProperty("--hero-control-color-desktop", desktopColor);
		});
	}
	createAutoplayOptions(hasMultipleSlides) {
		if (this.dataset.autoplay !== "true" || !hasMultipleSlides) return false;
		return {
			delay: Number(this.dataset.autoplayDelay),
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		};
	}
	handleBlockSelect(event) {
		const selectedBlock = event.target.closest(".shopify-block");
		const selectedSlide = selectedBlock?.querySelector(":scope > .hero__slide") || selectedBlock?.closest(".hero__slide");
		if (!selectedSlide || !this.carousel) return;
		const slideIndex = this.getSlideIndex(selectedSlide);
		if (slideIndex < 0) return;
		if (this.carousel.params.loop) this.carousel.slideToLoop(slideIndex, 0);
		else this.carousel.slideTo(slideIndex, 0);
		this.carousel.autoplay?.stop();
	}
	getSlideIndex(selectedSlide) {
		const slideWrapper = selectedSlide.closest(".hero__slides > .shopify-block");
		const loopIndex = Number(slideWrapper?.dataset.swiperSlideIndex);
		if (Number.isInteger(loopIndex)) return loopIndex;
		return Array.from(this.carousel.slides).indexOf(slideWrapper);
	}
};
if (!customElements.get("hero-carousel")) customElements.define("hero-carousel", HeroCarousel);
//#endregion
